export enum ActionTypes{
    LOGIN_REQUEST ="LOGIN_REUESTQ",
    LOGIN_SUCCESS ="LOGIN_SUCCESS",
    LOGIN_ERROR="LOGIN_ERROR",
    SIGNUP_REQUEST ="SIGNUP_REUESTQ",
    SIGNUP_SUCCESS ="SIGNUP_SUCCESS",
    SIGNUP_ERROR="SIGNUP_ERROR"
    }